// extracted by mini-css-extract-plugin
module.exports = {"customChip":"SubscriptionStatus_customChip__QZo5N","customChipOptional":"SubscriptionStatus_customChipOptional__3CX_F"};